export enum StoragePaths {
  AudioCoursesImages = "audioCourses/images",
  AudioCoursesFree = "audioCourses/free",
  AudioCoursesPremium = "audioCourses/premium",
  AudioCoursesHomeworkFree = "audioCourses/homework/free",
  AudioCoursesHomeworkPremium = "audioCourses/homework/premium",
  IntroCoursesImages = "introCourses/images",
  IntroCoursesFiles = "introCourses/files",
  OnlineCoursesWebImages = "onlineCoursesWeb/images",
  MeditationDailiesImages = "meditationDailies/images",
  MeditationDailiesFree = "meditationDailies/free",
  MeditationDailiesPremium = "meditationDailies/premium",
  AuthorsImages = "authors/images",
  DevelopersImages = "developers/images",
  ProfilePictures = "profilePictures",
  BlogArticlesImages = "blogArticles/images",
  Backups = "backups",
  PaywallProtected = "paywall/protected",
  PaywallPublic = "paywall/public",
  BlogArticlesDownloads = "blogArticles/downloads",
  SilentMeditationGenerated = "silentMeditation/generated",
  PodcastEpisodesImages = "podcastEpisodes/images",
  PodcastEpisodesDownloads = "podcastEpisodes/downloads",
  /** Public web downloads (handbooks, lead magnets, etc.). Private — served only via signed URLs. */
  WebDownloads = "web/downloads",
}
